<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/">
        <img
          class="navbar-brand-full d-md-down-none mx-2"
          src="@/../public/img/brand/entirelogo.svg"
          width="89"
          height="25"
          alt="Carlbot logo"
        />
        <img
          v-if="is_vip"
          class="navbar-brand-full d-md-down-none"
          src="@/../public/img/crown.png"
          width="15%"
          height="40%"
          alt="Carlbot logo"
        />
        <img
          class="navbar-brand-minimized"
          src="@/../public/img/brand/googleturtle.svg"
          width="30"
          height="30"
          alt="Carlbot logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none nav-title">
        <b-nav-item class="px-2" href="https://docs.carl.gg/">
          <i class="fas fa-book mr-1"></i>Docs
        </b-nav-item>
        <b-nav-item
          class="px-2"
          href="https://discord.com/oauth2/authorize?&client_id=235148962103951360&scope=applications.commands+bot&permissions=2088234230&response_type=code&redirect_uri=https://carl.gg/api/server_auth"
          exact
        >
          <i class="fas fa-plus mr-1"></i>Invite
        </b-nav-item>
        <b-nav-item class="px-2" href="https://discord.gg/S2ZkBTnd8X">
          <i class="fab fa-discord mr-1"></i>Discord
        </b-nav-item>
        <b-nav-item class="px-2" to="/status">
          <i class="fas fa-heartbeat mr-1"></i>Status
        </b-nav-item>
        <b-nav-item class="px-2" to="/gaming/deals">
          <i class="fas fa-gamepad"></i> Games
        </b-nav-item>
        <b-nav-item class="px-2" to="/server-discovery">
          <i class="fas fa-globe mr-1"></i>Discover
        </b-nav-item>
        <b-nav-item class="px-2 premium-nav-cta" href="/premium">
          <span class="premium-nav-cta__inner">
            <i class="fas fa-crown"></i> Premium
          </span>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="d-lg-none nav-title nav-icons">
        <b-nav-item to="/">
          <i class="fas fa-home"></i>
        </b-nav-item>
        <b-nav-item href="https://docs.carl.gg/">
          <i class="fas fa-book"></i>
        </b-nav-item>
        <b-nav-item
          href="https://discord.com/oauth2/authorize?&client_id=235148962103951360&scope=applications.commands+bot&permissions=2088234230&response_type=code&redirect_uri=https://carl.gg/api/server_auth"
          exact
          class="d-sm-down-none"
        >
          <i class="fas fa-plus"></i>
        </b-nav-item>
        <b-nav-item href="https://discord.gg/S2ZkBTnd8X" class="d-sm-down-none">
          <i class="fab fa-discord"></i>
        </b-nav-item>
        <b-nav-item to="/status">
          <i class="fas fa-heartbeat"></i>
        </b-nav-item>
        <b-nav-item to="/gaming/deals">
          <i class="fas fa-gamepad"></i>
        </b-nav-item>
        <b-nav-item to="/server-discovery">
          <i class="fas fa-globe"></i>
        </b-nav-item>
        <b-nav-item href="/premium" class="premium-nav-cta premium-nav-cta--icon">
          <span class="premium-nav-cta__inner">
            <i class="fas fa-crown"></i>
          </span>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto d-none d-sm-inline-block">
        <b-row v-if="logged_in">
          <b-col cols="12">
            <DefaultHeaderDropdownServer />
          </b-col>
        </b-row>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto ml-sm-4">
        <b-row v-if="logged_in">
          <b-col cols="12">
            <DefaultHeaderDropdownAccnt />
          </b-col>
        </b-row>
        <div v-else class="mr-auto">
          <b-button
            style="
              background-color: #3a4149;
              border-color: #eee;
            "
            v-on:click="login"
            class="px-md-3 btn-pill dark mr-md-2"
            >Login</b-button
          >
        </div>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <customSidebar :navItems="nav"></customSidebar>
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid" style="padding: 0 15px">
          <br />
          <!-- Old "Personalize" promo banner - commented out, replace with slash-command banner. Reinstate if needed.
          <p class="gameHeading" v-if="$route.name !== 'Personalize'">
            <span class="badge badge-custom-roblox align-middle">New</span>
            You can now change carl-bot's profile picture and banner with
            Premium!
            <b-link
              :to="`/dashboard/${$route.params.guild_id}/personalize`"
              class="ml-1"
            >
              Click here</b-link
            >
            to get started.
          </p>
          -->
          <p class="slashCommandBanner">
            <span class="badge badge-important align-middle">Important</span>
            {{ bannerText }}
            For more details
            <a
              href="https://docs.carl.gg/#/notice"
              target="_blank"
              rel="noopener noreferrer"
              class="noticeLink"
            >
              click here</a
            >
          </p>
          <br />
          <vue-progress-bar></vue-progress-bar>
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import DefaultHeaderDropdownServer from "./DefaultHeaderDropdownServer";
import customSidebar from "../components/customSidebar.vue";

export default {
  name: "DefaultContainer",
  components: {
    AppHeader,
    AppSidebar,
    DefaultHeaderDropdownAccnt,
    DefaultHeaderDropdownServer,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    customSidebar,
  },
  data() {
    return {
      discord_user: {},
      is_vip: false,
      server_id: {},
      imageUrl:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACtUlEQVR4nO1YS2sTURg9WnQjig9EETe+cJ0qqAt3rdKAIi58gcUudKELf4HiRpe+8A/UZRApSN0Iumht5vuSqAtBBVG6EJWmZO6dVoNor9whr2beqWYmOgcOhJm55zvnm/tgAqRIkSJFiqRCKSzXRC9CMo5LxqxklPVv9BIqBrZJwpxkKE3B+GaWsBO9AKWwTBCe1M03QhCe6XtIOiTjQrv5Bgnn/05RA8ck46MgvBEFZDvVmS9hiySYPgEq+plO9UUBWe3R9so4al9UOfRp4ZZXvSAI1/X1yAUIY57mm/pjUXVVDn2CcEN7a9GatXe42s2qoxDjqZXHprBFLMKJIPN16mfD6s4RNmsvLo2oNrZoSTBcu8X4ajEGgooIwgbB+BI2gCDMyBfYGKQrDRwUhE8eOvnmg4w7nsUYPwXhmt+BJAn3w5pv4ajvTsa4LAg/fNbT7cYAk3AmRMFH5hTWO7rPGOrAfL05R9r1ygbWCMKDoLGmgdPNAEXsCFWUMC2K2Fcf9/kVVknGh04DSML0zCRW1/UqjIwkvA8z1mRsX/zK9LwMN3+r+vXa3Sfc69h8k3dtLQPD+sQOOabsOBQlYTxi9x4Lwq+lBhBaI3rtcedCZFz9A93sDglXHAFMwuHYjXE4mgYOOQJUXmJt20mXSArCgjmBda77r2S864Hp89bV/BIOpG5z1DOAxbiUAIMqgBc9A5iEvQkwqPxoGtjjGUAVsSLCYdJ1CsZ39RorPQPUFvJU3EalFwnPfc3XFvKtBAe4GRjAYpyK3Si702KcDAxwYOhsqX9wRCWR+7PDhcAAmYGRybiN9nswM3huIjCAvQ4SMF2kC0OZ/1cCyLjNynYSzNABBONh7IZ5MfV3cpQAu2v/LKuEcFbksQtRMG9gq2DkJEPEaFzozkc2nyJFihQp/hv8Bs9/K/wQGZy+AAAAAElFTkSuQmCC",
      bannerTexts: [
        "Carl-bot has phased out prefix commands. Start using slash (/) commands today!",
      ],
      bannerText: "",
    };
  },
  beforeRouteUpdate(to, from, next) {
    if (this.server_id !== to.params.guild_id) {
      this.server_id = to.params.guild_id;
      this.fetchServerData();
      next();
    } else {
      next();
    }
  },
  created() {
    this.bannerText =
      this.bannerTexts[Math.floor(Math.random() * this.bannerTexts.length)];
    this.axios
      .get("/api/v1/servers/" + this.$route.params.guild_id + "/meta")
      .then((r) => {
        this.is_vip = r.data.is_vip;
      });
  },
  methods: {
    login() {
      this.$router.push("/api/login");
    },
    updateAuthInfo(e) {
      if (e.data.discriminator != undefined) {
        this.$store.commit("login", e.data);
      }
      window.removeEventListener("message", this.updateAuthInfo);
      this.$router.push("/servers");
    },
    fetchServerData() {
      this.axios
        .get(`/api/v1/servers/${this.server_id}/meta`)
        .then((response) => {
          this.prefixes = response.data.prefixes;
          this.is_vip = response.data.is_vip;
          this.expiryDate = new Date(response.data.expires).getTime();
          this.is_piggy = response.data.is_piggy;
        });
    },
  },
  computed: {
    nav() {
      const viewerCountryCode =
        this.$store.state &&
        this.$store.state.user_geo &&
        this.$store.state.user_geo.viewerCountryCode;
      nav.items.filter((item) => {
        if (item.name === "Quick setup") {
          item.url = "/onboarding/" + this.$route.params.guild_id;
          return true;
        }
        return true;
      });
      return (
        nav.items &&
        nav.items.filter((item) => {
          if (item.url === "games") {
            return viewerCountryCode === "US";
          } else {
            return true;
          }
        })
      );
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label,
      );
    },
    logged_in() {
      return Object.keys(this.$store.state.discord_user).length !== 0;
    },
    current_guild() {
      return this.$store.state.discord_guilds.find(
        (x) => x.id == this.$route.params.guild_id,
      );
    },
  },
};
</script>
<style src="spinkit/spinkit.min.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* Keep the header on one row on mobile so the avatar dropdown doesn't wrap. */
@media (max-width: 991.98px) {
  .app-header.navbar {
    flex-wrap: nowrap;
  }
  .app-header .nav-icons .nav-item {
    min-width: 0;
  }
  .app-header .nav-icons .nav-link {
    padding-left: 0.4rem;
    padding-right: 0.4rem;
  }
  .app-header .navbar-brand {
    width: auto;
    padding: 0 0.5rem;
  }
}

.multiselect--active {
  z-index: 3 !important;
}

.multiselect,
.multiselect__input,
.multiselect__single {
  color: #eee !important;
}
.multiselect__input,
.multiselect__single {
  background: #515b65 !important;
  color: #fff !important;
  padding-left: 0px !important;
  padding-top: 2px !important;
  margin-bottom: 11px !important;
}
.multiselect__input::placeholder {
  color: #ddd !important;
  font-size: 14px;
}
.multiselect__tags {
  border: 1px solid #232823 !important;
  background: #515b65 !important;
}
.multiselect__tag {
  background: #2f353a !important;
  border-width: 1px !important;
  border-style: solid;
  border-radius: 500px;
  padding: 5px 10px 4px 26px !important;
  cursor: default;
}

.multiselect__option .multiselect__option--group {
  background-color: #2e343a !important;
  color: #eee;
}

.channelpicker__tag {
  border-radius: 6px !important;
  border-color: #eeeb !important;
}

.multiselect__tag-icon {
  left: -5px !important;
}

.multiselect__tag:hover .multiselect__tag-icon:after {
  content: "\D7";
  color: #fff;
  font-size: 14px;
  margin: -3.5px 0px 10px -4px;
  position: absolute;
}

.multiselect__tag-icon:after {
  content: "\D7";
  color: #fff0;
  font-size: 12px;
  margin: -3.5px 0px 10px -3.5px;
  position: absolute;
}

.multiselect__select:before {
  color: #2f353a !important;
  border-color: #2f353a transparent transparent !important;
}
.defaultcursor {
  cursor: default;
}
.multiselect__placeholder {
  color: #adadad !important;
}
.multiselect--active .multiselect__placeholder {
  color: #eee !important;
}
.multiselect__content-wrapper {
  background: #3a4149 !important;
  border: 1px solid #2f353a !important;
}
.multiselect--above .multiselect__content-wrapper {
  border-top: 1px solid #2f353a !important;
}
.multiselect__option--selected {
  background: #515b65 !important;
}

.fakediscord {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin: 4px 10px 11px 9px;
  cursor: pointer;
}

.gameHeading {
  background: #4d53bd;
  padding: 4px;
  border-radius: 5px;
  margin: 0;
}

.slashCommandBanner {
  background: #f0ad4e;
  color: #2f353a;
  padding: 4px;
  border-radius: 5px;
  margin: 0;
}

.badge-important {
  background-color: #4d53bd;
  color: #fff;
  font-size: 1em;
}

.noticeLink {
  color: #4d53bd;
  font-weight: bold;
  text-decoration: underline;
}

.noticeLink:hover {
  color: #3a3f92;
}

.channelpicker_icon {
  background-color: #00000000 !important;
  border-radius: 0;
  border-width: 1px;
  border-style: none solid none none;
  border-color: #eeeb;
  width: 23px;
  height: 25px;
  margin: -1px -4px -20px 4px;
  padding-top: 5px;
}

.channelpicker_icon:after {
  content: "\D7";
  color: #999;
  font-size: 14px;
  margin: -3.5px 0px 10px -4px;
  position: absolute;
}

.multiselect__option--group {
  background-color: #2e343a !important;
  color: #eee !important;
}

.multiselect__option.multiselect__option--selected
  .option__desc
  .option__title {
  color: #bbb !important;
}

.multiselect__spinner {
  background: #515b65 !important;
}

.vc-sketch {
  background-color: #2f353a !important;
  position: absolute !important;
  z-index: 200;
}
.vc-sketch:active {
  user-select: none;
}

.vc-input__input {
  background-color: #515b65 !important;
  color: #eee !important;
  box-shadow: inset 0 0 0 1px #111 !important;
}
.vc-input__label {
  color: #eee !important;
}
.vc-sketch-alpha-wrap {
  display: none;
}
</style>
